<div class="visible-fields-selector">
  <app-shared-button [colour]="'clear'" (buttonClicked)="onVisibleFieldsButtonClick($event)">
    <app-display-icon [icon]="icons.eyeOutline" [colour]="iconColourEnum.white"></app-display-icon>
    @if (!isMobile) {
      Visible Fields
    }
  </app-shared-button>
  <app-shared-custom-select
    #visibleFieldsSelect
    [setOptions]="getVisibleFieldsOptions"
    [selected]="getSelectedVisibleFields"
    [allowMultiple]="true"
    [allowSelectAll]="true"
    [showSearchBar]="true"
    [showChips]="false"
    [setDefault]="getDefaultFields"
    [saveLoad]="!!document"
    [placeholder]="'Visible Fields'"
    (saveLoadClick)="onVisibleFieldSaveButtonClick($event)"
    (selectionChange)="onVisibleFieldsChange($event)">
  </app-shared-custom-select>
</div>


